import Gantt from "./Gantt";

export default Gantt;
